import React, { useState } from "react";
import Chart from "react-apexcharts";
import { Badge, Button, Row, Card, CardBody, CardHeader } from "reactstrap";
import moment from "moment";

const allDishes = [
  { label: "Caesar Salad", value: "caesar", color: "#EF4444" },
  { label: "Margherita Pizza", value: "pizza", color: "#3B82F6" },
  { label: "Spaghetti Carbonara", value: "carbonara", color: "#10B981" },
  { label: "Tiramisu", value: "tiramisu", color: "#F59E0B" },
  { label: "French Fries", value: "fries", color: "#8B5CF6" },
  { label: "Chocolate Cake", value: "cake", color: "#EC4899" },
  { label: "Mojito", value: "mojito", color: "#14B8A6" },
  { label: "Wine", value: "wine", color: "#6366F1" },
];

// Generate dummy data
const generateData = () => {
  const data = {};
  const today = moment();

  allDishes.forEach((dish) => {
    const dishData = [];

    for (let i = 0; i < 30; i++) {
      dishData.push({
        x: today.clone().add(i, 'days').format('MM/DD'),
        y: Math.floor(Math.random() * 30 + 30), // Random between 30–59
      });
    }

    data[dish.value] = dishData;
  });

  return data;
};

const chartData = generateData();



const DishLineChart = () => {
  const [selected, setSelected] = useState(["caesar", "pizza"]);

  const handleSelect = (dish) => {
    setSelected((prev) =>
      prev.includes(dish)
        ? prev.filter((d) => d !== dish)
        : prev.length < 4
        ? [...prev, dish]
        : prev
    );
  };

  const chartSeries = selected.map((dishId) => {
    const dish = allDishes.find((d) => d.value === dishId);
    return {
      name: dish.label,
      data: chartData[dishId],
    };
  });

  const chartColors = selected.map(
    (dishId) => allDishes.find((d) => d.value === dishId).color
  );

  const chartOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
    },
    colors: chartColors,
    stroke: { curve: "smooth", width: 3 },
    markers: { size: 4 },
    xaxis: {
      type: "category",
      labels: {
        rotate: -45,
        rotateAlways: true, 
        formatter: (val) => moment(val).format("DD/MM"),
      },
    },

    yaxis: {
      labels: { formatter: (val) => `${val}` },
    },
    tooltip: {
      x: { format: "dddd, DD MMM" },
      y: { formatter: (val) => `${val}%` },
    },
    legend: {
      show: true,
      position: "bottom",
    },
  };

  return (
    <Row>
      <Card>
          <CardHeader className="ps-0 border-0 align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">Dish Benchmark Playground</h4>            
          </CardHeader>
          <CardBody className="p-0">
          <div>
            <div className="d-flex gap-2 mb-4">
              {allDishes.map((dish) => (
                <span
                    key={dish.value}
                    onClick={() => handleSelect(dish.value)}
                    style={{
                      padding: "0.65rem 1rem",
                      backgroundColor: selected.includes(dish.value)
                        ? dish.color
                        : "#f1f5f9",
                      color: selected.includes(dish.value) ? "#fff" : "#000",
                      borderRadius: "10px",
                      cursor: "pointer",
                      border: "1px solid #ccc",
                      display: "inline-block",
                    }}
                  >
                    {dish.label}
                  </span>

              ))}
              <Button size="sm" color="light" className="ms-auto">
                Normalize by Covers
              </Button>
            </div>

            <Chart
              options={chartOptions}
              series={chartSeries}
              type="line"
              height={350}
            />
          </div>
          </CardBody>
        </Card>
      </Row>
  );
};

export default DishLineChart;
